export default __webpack_public_path__ + "static/media/member4.9045579a.jpg";